import React from 'react';

const Spinner = () => (
  <div className="ui-loading">
    <div className="h-6 w-6 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
  </div>
);

export default Spinner;
